// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-console */
import { pushUrl } from "../services/history/historyActions"
import bindWindowGlobalFunctions from "../../../app/scripts/tools/bindWindowGlobalFunctions"
import { updateGlobals } from "../../../app/scripts/tools/translate"
import { setLocale, getTranslations } from "../services/intl"

// Due to 404 tracking
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function initHistory(store: any) {
  store.dispatch(pushUrl(window.location.href))
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function applyTranslations(store: any) {
  // @ts-expect-error: Flow to TS migration.
  const { translations } = window.__INTL__
  // @ts-expect-error: Flow to TS migration.
  if (__DEV__ && !translations) console.error("missing translations")
  store.dispatch(setLocale(translations))

  const fedTranslations = getTranslations(store.getState())
  updateGlobals(fedTranslations)
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function preRender(store: any) {
  initHistory(store)
  applyTranslations(store)
  bindWindowGlobalFunctions()
}
